import { render } from "./RulesComponent.vue?vue&type=template&id=a40deae8"
import script from "./RulesComponent.vue?vue&type=script&lang=js"
export * from "./RulesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__